import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import {
  Loading,
  Tooltip,
  TruncateAndTooltip,
  MessageBox
} from 'mailup-web-components'
import { Previewer } from './Previewer'
import classnames from 'classnames'
import './PreviewTools.scss'

export const PreviewTool = ({
  children,
  TabsComponent,
  HeadComponent,
  previewers,
  title,
  loading,
  error
}) => {
  const intl = useIntl()

  return (
    <div className='c-preview'>
      {error ? (
        <div className='t-preview__error'>
          <MessageBox variant='danger'>
            {intl.formatMessage({ id: 'Load.Common.Error' })}
          </MessageBox>
        </div>
      ) : (
        <>
          <Tooltip place='bottom' />
          <Loading open={loading} />
          <div>
            <header className='c-preview__head'>
              {title && (
                <h1 className='c-preview__title' data-mu-test='template-title'>
                  <TruncateAndTooltip text={title} />
                </h1>
              )}
              {HeadComponent && <HeadComponent />}
            </header>
            {TabsComponent && <TabsComponent />}
            {previewers && previewers.length && (
              <div className='c-preview__previews'>
                {previewers.map(({ active, ...props }, i) => (
                  <div
                    key={`previewer-${i}`}
                    className={classnames('c-preview__preview', {
                      'c-preview__preview--active': active
                    })}
                  >
                    <Previewer {...props} />
                  </div>
                ))}
              </div>
            )}
            {children}
          </div>
        </>
      )}
    </div>
  )
}

PreviewTool.propTypes = {
  TabsComponent: PropTypes.any,
  HeadComponent: PropTypes.any,
  previewers: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
  content: PropTypes.string,
  loading: PropTypes.bool,
  error: PropTypes.string,
  children: PropTypes.any
}
